module.exports = __webpack_public_path__ + "img/48.9.TU.1ace95c0.png";